import {
  Box,
  InputAdornment,
  InputLabel,
  Switch,
  Typography
} from '@material-ui/core';
import clsx from 'clsx';
import React from 'react';
import useStyles from '../styles';

export const CustomSwitchWithText = ({ checked, size, ...props }) => {
  const classes = useStyles();
  return (
    <Box className={classes.customSwitchContainer}>
      <Switch
        checked={checked}
        classes={{
          root: clsx(
            classes.customSwitchRoot,
            size === 'small' && classes.customSwitchSmall
          ),
          switchBase: classes.customSwitchBase,
          thumb: classes.customSwitchThumb,
          track: classes.customSwitchTrack,
          checked: classes.customSwitchChecked
        }}
        {...props}
      />
    </Box>
  );
};

export function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`edit-device-tabpanel-${index}`}
      aria-labelledby={`edit-device-tab-${index}`}
      {...other}
    >
      {value === index && <Box pt={1}>{children}</Box>}
    </div>
  );
}

export function a11yProps(index) {
  return {
    id: `edit-device-tab-${index}`,
    'aria-controls': `edit-device-tabpanel-${index}`
  };
}

export function SectionTitle({ title, extra }) {
  const classes = useStyles();

  return (
    <Box className={classes.sectionTitleRow}>
      <Box className={classes.sectionTitleMain}>
        <Box className={classes.sectionTitleAccent} />
        <Typography className={classes.sectionTitleText}>{title}</Typography>
      </Box>
      {extra && (
        <Typography className={classes.sectionTitleExtra}>{extra}</Typography>
      )}
    </Box>
  );
}

// noWrap: giữ nhãn trên 1 dòng (cắt "…", hover xem đủ) để input các cột cùng hàng không bị lệch
export function FieldLabel({ children, required, hint, noWrap, className = '' }) {
  const classes = useStyles();

  return (
    <InputLabel
      className={clsx(classes.fieldLabel, noWrap && classes.fieldLabelNoWrap, className)}
      title={noWrap && typeof children === 'string' ? children : undefined}
    >
      {noWrap ? <span className={classes.fieldLabelText}>{children}</span> : children}
      {hint && <span className={classes.fieldHint}>{hint}</span>}
      {required && <span className={classes.requiredMark}>*</span>}
    </InputLabel>
  );
}

export function FieldIcon({ icon: Icon }) {
  const classes = useStyles();

  return (
    <InputAdornment position="end">
      <Icon className={classes.fieldIcon} />
    </InputAdornment>
  );
}

export function FeatureCard({
  title,
  badge,
  badgeTone = 'warning',
  statusLabel = 'Trạng thái',
  children
}) {
  const classes = useStyles();

  return (
    <Box className={classes.featureCard}>
      <Box className={classes.featureCardHead}>
        <Typography className={classes.featureCardTitle}>{title}</Typography>
        {badge && (
          <span
            className={clsx(
              classes.featureBadge,
              badgeTone === 'success'
                ? classes.featureBadgeSuccess
                : classes.featureBadgeWarning
            )}
          >
            {badge}
          </span>
        )}
      </Box>
      <Box className={classes.featureCardFoot}>
        <Typography className={classes.featureCardStatus}>
          {statusLabel}
        </Typography>
        {children}
      </Box>
    </Box>
  );
}
